import type { AdminApiOrganization } from '@/types/serializers';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type CreateAdminOrganizationParams = {
  companyName: string;
  name: string;
  email: string;
};

type CreateAdminOrganizationResponse =
  | AdminApiOrganization
  | {
      data?: AdminApiOrganization;
    };

const normalizeOrganization = (
  payload: CreateAdminOrganizationResponse
): AdminApiOrganization | null => {
  if ('id' in payload) {
    return payload;
  }
  return payload.data ?? null;
};

export default function useCreateAdminOrganization() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (params: CreateAdminOrganizationParams) => {
      const response = await fetch('/admin/api/organizations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token || '',
        },
        body: JSON.stringify({
          company_name: params.companyName,
          name: params.name,
          email: params.email,
        }),
      });
      if (!response.ok) {
        throw new Error('クライアントの作成に失敗しました');
      }
      const data: CreateAdminOrganizationResponse = await response.json();
      const organization = normalizeOrganization(data);
      if (!organization) {
        throw new Error('クライアント情報の取得に失敗しました');
      }
      return organization;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'organizations'] });
    },
  });
}
